/**
 * German typography helpers.
 *
 * German compound nouns are long enough to overflow a phone on their own:
 * "Sondereigentumsverwaltung" is 25 characters and, at the mobile h2 size,
 * wants ~350px against ~335px of available width.
 *
 * `hyphens: auto` fixes the overflow but breaks in the wrong place - Chrome's
 * German dictionary renders "Sondereigentum" as "Sonde-reigentum", which reads
 * as a typo. So hyphenation stays manual and the compounds that appear at
 * display sizes carry an explicit break at the correct morpheme boundary.
 *
 * Only for visible text. Never put a soft hyphen in a <title>, a meta
 * description, a URL or structured data - it is a real character that would
 * end up in search results.
 */

/** U+00AD SOFT HYPHEN: invisible unless the line actually breaks there. */
export const SHY = '\u00AD'

/**
 * Join word parts with soft hyphens.
 *
 *   hy('Sonder', 'eigentums', 'verwaltung')
 *   -> renders as "Sondereigentumsverwaltung", may break as "Sonder-" / "eigentums-"
 */
export const hy = (...parts) => parts.join(SHY)
